export const parseLockers = (lockers: any) =>
	lockers.map((locker: any) => ({
		id: locker.id,
		...locker
	}))
